import { render } from "./year.vue?vue&type=template&id=f7fd6cd4&scoped=true"
import script from "./year.vue?vue&type=script&lang=js"
export * from "./year.vue?vue&type=script&lang=js"

import "./year.vue?vue&type=style&index=0&id=f7fd6cd4&lang=less&scoped=true"

import exportComponent from "D:\\work\\ask_cloud\\QC\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f7fd6cd4"]])

export default __exports__